import React, { useContext } from "react";
import "./SwitchButton.css";
import { ThemeContext } from "../../../contexts";

interface SwitchButtonProps {
	checked: boolean;
	onToggle: () => void;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({ checked, onToggle }) => {
	const { theme } = useContext(ThemeContext);
	return (
		<div className="switch-container">
			<form className="toggle" style={{ borderColor: theme.primary_color }}>
				<input type="radio" id="choice1" name="choice" value="ES" checked={checked} onChange={onToggle} />
				<label htmlFor="choice1" style={{ color: theme.primary_color }}>
					ES
				</label>

				<input type="radio" id="choice2" name="choice" value="EN" checked={!checked} onChange={onToggle} />
				<label htmlFor="choice2" style={{ color: theme.primary_color }}>
					EN
				</label>

				<div
					id="flap"
					style={{ backgroundColor: theme.button.background_color }}
					className={checked ? "flap-checked" : "flap-unchecked"}
				>
					<span className="content" style={{ color: theme.button.color }}>
						{checked ? "ES" : "EN"}
					</span>
				</div>
			</form>
		</div>
	);
};

export default SwitchButton;
